export default "__VITE_ASSET__24339821__"